import { Book, Users, Award, Heart } from "lucide-react";

const About = () => {
  const features = [
    {
      icon: Book,
      title: "Tradiție",
      description: "Peste 20 de ani de experiență în arta legătoriei în piele",
      color: "primary",
    },
    {
      icon: Heart,
      title: "Pasiune",
      description: "Fiecare carte este creată cu dedicație și atenție la detalii",
      color: "accent",
    },
    {
      icon: Award,
      title: "Calitate",
      description: "Materiale premium și tehnici tradiționale de lucru manual",
      color: "gold",
    },
    {
      icon: Users,
      title: "Familie",
      description: "O afacere de familie bazată pe încredere și profesionalism",
      color: "burgundy",
    },
  ];

  return (
    <section id="despre" className="py-20 bg-gradient-to-b from-background to-cream/30 relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-72 h-72 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto text-center mb-12 sm:mb-16 animate-fade-in">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-primary/10 rounded-full mb-4 sm:mb-6">
            <Book className="w-3 h-3 sm:w-4 sm:h-4 text-primary" />
            <span className="text-primary font-semibold text-xs sm:text-sm">Povestea noastră</span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-4 sm:mb-6 px-2">
            Idaco ..dar din har..
          </h2>
          
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-4 sm:mb-6 font-lora px-4">
            Activitatea noastră s-a zămislit din dragoste pentru "românesc". Creațiile atelierelor 
            <strong> Idaco ..dar din har.. </strong>au ca izvoare de viață credința ortodoxă, cultura tradițională 
            românească și istoria noastră.
          </p>
          
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed font-lora px-4">
            Grija pentru execuție, detalii, creativitatea care se regăsește în seriile mici și unicat 
            ale produselor noastre, în cei 20 ani de activitate, au făcut ca <strong>Idaco ..dar din har..</strong> să 
            devină un brand apreciat de toți cei ce iubesc "frumosul" născut din credință și pasiune.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className="group p-5 sm:p-6 bg-card/80 backdrop-blur-sm rounded-2xl border-2 border-border/50 hover:border-primary/30 transition-all duration-500 hover-scale hover-glow animate-fade-in"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className={`w-14 h-14 sm:w-16 sm:h-16 bg-${feature.color}/10 rounded-2xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className={`w-7 h-7 sm:w-8 sm:h-8 text-${feature.color}`} />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                  {feature.title}
                </h3>
                <p className="text-sm sm:text-base text-muted-foreground font-lora leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-12 sm:mt-16 text-center animate-fade-in px-4" style={{ animationDelay: '0.6s' }}>
          <div className="inline-block p-6 sm:p-8 bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl sm:rounded-3xl border-2 border-primary/20">
            <p className="text-xl sm:text-2xl md:text-3xl font-bold text-primary mb-3 sm:mb-4">
              Transformăm cărțile în moșteniri de familie
            </p>
            <p className="text-sm sm:text-base text-muted-foreground font-lora max-w-2xl mx-auto">
              Fiecare carte pe care o creăm este destinată să reziste generațiilor 
              și să devină o comoară de familie prețuită.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
